import React, { Component } from 'react';
import './Drawer.css';
import Backdrop             from '../Backdrop/Backdrop';
import { NavLink }          from 'react-router-dom';

class Drawer extends Component {
    renderLinks(links) {
        return links.map(({ to, label, exact }, index) => {
            return (
                <li key={ index }>
                    <NavLink
                        to={ to }
                        exact={ exact }
                        activeClassName="active"
                        onClick={ this.props.onClose }
                    >
                        { label }
                    </NavLink>
                </li>
            );
        });
    }

    render() {
        let { links } = this.props;
        const cls = ['drawer'];

        if (!this.props.isOpen) {
            cls.push('close');
        }

        return (
            <React.Fragment>
                <nav className={ cls.join(' ') }>
                    <ul>
                        { this.renderLinks(links) }
                    </ul>
                </nav>
                { this.props.isOpen ? <Backdrop onClick={ this.props.onClose }/> : null }
            </React.Fragment>
        );
    }
}

export default Drawer;